module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_rogaland_neg.748ec576.pdf";